import styled from "styled-components";
import { MyProps } from "../../utils/theme";

export const Wrapper = styled.main`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  color: ${({ theme }: MyProps) => theme.colors.white};
  max-width: 15em;
  width: 100%;
`;
